import { Platform, Text } from 'react-native';
import { COLOR, FONT_SIZE, FONT_WEIGHT } from 'constants/design-system';

import type { TextProps, TextStyle } from 'react-native';

export type BaseTextProps = Pick<
  TextProps,
  'style' | 'children' | 'numberOfLines' | 'ellipsizeMode'
> &
  Pick<TextStyle, 'fontSize' | 'fontWeight' | 'color' | 'textAlign'>;

export const BaseText = (props: BaseTextProps) => {
  const {
    children,
    style,
    color = COLOR.theme.black,
    fontSize = FONT_SIZE.theme.base,
    fontWeight = FONT_WEIGHT.theme.normal,
    textAlign = 'auto',
    numberOfLines,
    ellipsizeMode,
  } = props;
  return (
    <Text
      numberOfLines={numberOfLines}
      ellipsizeMode={ellipsizeMode}
      style={[
        {
          fontSize,
          color,
          fontWeight,
          textAlign,
          flexShrink: 1,
        },
        // NOTE: metro web doesn't work break like in native code
        Platform.OS === 'web' && ({ wordBreak: 'break-word' } as TextStyle),
        style,
      ]}
    >
      {children}
    </Text>
  );
};
